import { useCallback, useEffect, useState } from 'react';

import { ApiCommand } from '~/lib/Api';
import { OrganizeBy } from '~/lib/constants/task.constants';
import urlConstants from '~/lib/constants/url.constants';
// TODO: GX-3744 - Replace deprecated useApi calls with RTK Query
import { useApi } from '~/lib/hooks';
import { FetchTasksResponse, TaskStatusLabel } from '~/lib/util/task.util';

const { listTasks: listTasksUrl } = urlConstants.tasks;

interface PatientTaskCounts {
  familyTaskCount: number | undefined;
  maudTaskCount: number | undefined;
  totalCount: number;
}

const usePatientTaskCount = (patientId: string): PatientTaskCounts => {
  const [maudTaskCount, setMaudTaskCount] = useState<number | undefined>();
  const [familyTaskCount, setFamilyTaskCount] = useState<number | undefined>();

  const { data: maudTasksData, sendRequest: getMaudTasks } =
    useApi<FetchTasksResponse>();
  const { data: familyTasksData, sendRequest: getFamilyTasks } =
    useApi<FetchTasksResponse>();

  const fetchCounts = useCallback((): void => {
    if (!patientId) return;
    const baseFilterBy = {
      'patient-external-id': patientId,
      status: [TaskStatusLabel.TO_DO, TaskStatusLabel.IN_PROGRESS],
    };
    getMaudTasks({
      command: ApiCommand.GET,
      options: {
        'filter-by': { ...baseFilterBy, 'is-family-task': false },
        'order-by': OrganizeBy.DUE_DATE,
        'page-number': 1,
        'page-size': 1,
      },
      url: listTasksUrl,
    });
    getFamilyTasks({
      command: ApiCommand.GET,
      options: {
        'filter-by': { ...baseFilterBy, 'is-family-task': true },
        'order-by': OrganizeBy.CREATED_DATE,
        'page-number': 1,
        'page-size': 1,
      },
      url: listTasksUrl,
    });
  }, [patientId]);

  useEffect(() => {
    fetchCounts();
  }, [fetchCounts]);

  useEffect(() => {
    if (maudTasksData !== null && familyTasksData !== null) {
      const maud = maudTasksData?.totalCount ?? 0;
      const family = familyTasksData?.totalCount ?? 0;
      setMaudTaskCount(maud);
      setFamilyTaskCount(family);
    }
  }, [maudTasksData?.totalCount, familyTasksData?.totalCount]);

  const totalCount = (maudTaskCount ?? 0) + (familyTaskCount ?? 0);

  return { familyTaskCount, maudTaskCount, totalCount };
};

export default usePatientTaskCount;
